<template>
  <main class="main h-100 bg-secondary overflow-hidden">
    <div class="container-fluid p-0 h-100 d-none d-lg-block">
      <div
        class="h-100 d-flex"
      >
        <div
          class="h-100 flex-grow-0 flex-shrink-0"
        >
          <TheSidebar />
        </div>
        <div
          id="dashboard-main-view"
          class="flex-grow-1 p-0 overflow-hidden"
        >
          <div
            v-if="isLoading"
            class="h-100 align-items-center d-flex bg-secondary justify-content-center card-body"
            data-test="dashboard-loading"
          >
            <div class="loader mx-auto" />
          </div>
          <slot v-else />
        </div>
      </div>
    </div>
    <b-container
      fluid
      class="mt-7 d-block d-lg-none"
    >
      <b-row class="justify-content-center">
        <b-col class="col-auto">
          <b-card
            no-body
          >
            <b-card-body>
              <h4 class="text-center my-5">
                This Dashboard must be viewed on a bigger screen
              </h4>
              <p>
                For the best user experience, we have optimised this application
                for screen resolutions of greater than 990 pixels. Please change
                your display settings.
              </p>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>
<script>
import { Auth } from 'aws-amplify';
import { mapActions } from 'vuex';
import * as authenticationTypes from '@/modules/authentication/store/types';
import TheSidebar from '@/components/TheSidebar';

export default {
  name: 'BaseDashboard',
  components: {
    TheSidebar,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    ...mapActions('authentication', [
      authenticationTypes.SIGN_OUT,
    ]),
  },
  async mounted() {
    try {
      await Auth.currentAuthenticatedUser()
        .catch(() => {
          this.SIGN_OUT()
            .then(() => {
              this.$router.push('/login');
            });
        });
    } catch (e) {
      this.SIGN_OUT()
        .then(() => {
          this.$router.go('/login');
        });
    }
  },
};
</script>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #47474E;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #47474E;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
